// import axios from "axios";
// import { REACT_APP_API_BASE_URL } from "../apiurl";
import api from "./api";

const API_URL = `/control-tradingdays`;

export const ControlTradingDaysService = {
    getAll: async (params = {}) => {
        const response = await api.get(API_URL, { params });
        return response.data;
    },

    create: async (data) => {
        const response = await api.post(API_URL, data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`${API_URL}/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`${API_URL}/${id}`);
        return response.data;
    },
};
